import { CiapCidSugestao } from 'graphql/types.generated'

export const isCiapCidInListaObrigatorios = (
  ciapsCidsObrigatorios: ReadonlyArray<CiapCidSugestao>,
  ciapId: ID,
  cid10Id: ID
) =>
  (ciapsCidsObrigatorios ?? []).some(
    (problema) => problema && ciapId === problema.ciap?.id && cid10Id === problema.cid10?.id
  )

export function ciapCidCodigoToFormkey(codigoCiap?: string, codigoCid10?: string): string {
  return (codigoCiap ?? '-') + '-' + (codigoCid10 ?? '-')
}
